var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('section',{staticClass:"home__filters"},[_c('filter-mobile',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMobile),expression:"isMobile"}]}),_c('filter-desktop',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMobile),expression:"!isMobile"}]})],1),_c('grid-header'),_c('grid-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }